<template>
    <div class="personal-data-wrapper">
        <app-header-mini :img="'/static/img/personal_data/header.jpg'"></app-header-mini>
        <div class="personal-data-content">
            <h1 class="indent">Politica sulla privacy</h1>
            <p class="indent"><a href="/static/files/GDPR-Personal-Data-Information.pdf" target="_blank">Informazioni sui dati personali</a></p>
        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.personal-data-content {
  padding: 0 0 60px;
}
.personal-data-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.personal-data-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 15px auto;
  width: 800px;
}
@media screen and (max-width: 1000px) {
  .personal-data-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .personal-data-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalData.vue